var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"client_profile","grid-list-md":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"lg":"6"}},[_c('client-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }